//--- ARQUIVO ATUALIZADO: TransactionForm.js (Etapa 3 - Seleção de Conta) ---
import React, { useState, useEffect, useMemo } from 'react';

const formatCurrencyInput = (value) => { const numericValue = String(value).replace(/[^\d]/g, ''); if (!numericValue) return ''; const number = parseInt(numericValue, 10) / 100; return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(number); };

// Adicionamos 'accounts' como prop
export const TransactionForm = ({ onSubmit, onCancel, showNotification, initialData = null, categories, clients, products, accounts }) => {
    const [transaction, setTransaction] = useState({
        descricao: '', valor: '', data: new Date().toISOString().split('T')[0],
        natureza: initialData?.tipo || 'receita',
        tipo: initialData?.tipo || 'receita',
        categoryId: initialData?.categoryId || '',
        clientId: initialData?.clientId || '',
        accountId: initialData?.accountId || '', // <-- NOVO CAMPO DE ESTADO
        isInstallment: initialData?.isInstallment || false,
        installments: initialData?.installments || 2,
        status: initialData?.status || 'pago',
        vencimento: initialData?.vencimento || '',
        formaPagamento: initialData?.formaPagamento || 'pix',
        ...initialData
    });
    const [isSaving, setIsSaving] = useState(false);

    // Define accountId inicial ou o primeiro da lista se nenhum for fornecido
    useEffect(() => {
        if (!initialData && accounts && accounts.length > 0 && !transaction.accountId) {
             setTransaction(prev => ({ ...prev, accountId: accounts[0].id }));
        } else if (initialData && !initialData.accountId && accounts && accounts.length > 0) {
             setTransaction(prev => ({ ...prev, accountId: accounts[0].id }));
        } else if (initialData && initialData.accountId) {
             setTransaction(prev => ({ ...prev, accountId: initialData.accountId }));
        }
    }, [initialData, accounts]); // Depende de accounts agora


    useEffect(() => {
        if (initialData) {
            const formattedInitialData = {
                ...initialData,
                natureza: initialData.tipo,
                valor: initialData.valor ? formatCurrencyInput(initialData.valor * 100) : '',
                formaPagamento: initialData.formaPagamento || (initialData.tipo === 'receita' || initialData.tipo === 'despesa' ? 'pix' : ''),
                categoryId: initialData.categoryId || '',
                clientId: initialData.clientId || '',
                accountId: initialData.accountId || (accounts && accounts.length > 0 ? accounts[0].id : ''), // Garante accountId
                isInstallment: initialData.isInstallment || false,
                installments: initialData.installments || 2,
                status: initialData.status || 'pago',
                vencimento: initialData.vencimento || '',
            };
            setTransaction(prev => ({...prev, ...formattedInitialData}));
        } else {
             // Reset para adicionar novo
             const defaultType = 'receita';
             setTransaction({
                 descricao: '', valor: '', data: new Date().toISOString().split('T')[0],
                 natureza: defaultType, tipo: defaultType,
                 categoryId: '', clientId: '',
                 accountId: accounts && accounts.length > 0 ? accounts[0].id : '', // Define a primeira conta como padrão
                 isInstallment: false,
                 installments: 2, status: 'pago', vencimento: '',
                 formaPagamento: 'pix',
             });
        }
    }, [initialData, accounts]); // Depende de accounts

    const handleCatalogSelect = (e) => {
        const productId = e.target.value;
        if (!productId) return;
        const selectedProduct = products.find(p => p.id === productId);
        if (selectedProduct) { setTransaction(prev => ({ ...prev, descricao: selectedProduct.name, valor: formatCurrencyInput(selectedProduct.price * 100) })); }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setTransaction(prev => {
            let newState = { ...prev, [name]: type === 'checkbox' ? checked : value };
            if (name === 'valor') { newState[name] = formatCurrencyInput(value); }
            if (name === 'status' && value === 'pendente' && !newState.vencimento) {
                 newState.vencimento = newState.vencimento || newState.data || new Date().toISOString().split('T')[0];
            } else if (name === 'status' && value === 'pago') {
                 newState.data = newState.data || new Date().toISOString().split('T')[0];
            }
             if (name === 'data' && newState.status === 'pendente' && !newState.vencimento) {
                 newState.vencimento = value;
             }

            if (name === 'natureza') {
                newState.tipo = value;
                newState.categoryId = '';
                newState.clientId = '';
                newState.categoryName = '';
                newState.clientName = '';

                if (value === 'aporte' || value === 'retirada') {
                    newState.formaPagamento = '';
                    newState.isInstallment = false;
                } else if (!prev.formaPagamento || prev.tipo === 'aporte' || prev.tipo === 'retirada') {
                    newState.formaPagamento = 'pix';
                } else {
                     newState.formaPagamento = prev.formaPagamento || 'pix';
                }
            }
            return newState;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const valorNumerico = parseFloat(String(transaction.valor).replace(/\./g, '').replace(',', '.'));
        const isOperational = transaction.tipo === 'receita' || transaction.tipo === 'despesa';
        const selectedCategory = isOperational ? categories.find(c => c.id === transaction.categoryId) : null;

        // --- VALIDAÇÃO ADICIONAL ---
        if (!transaction.accountId) {
             showNotification("Selecione a conta financeira para esta movimentação."); return;
        }
        // --- FIM DA VALIDAÇÃO ---

        if (!transaction.descricao.trim()) {
             showNotification("A descrição é obrigatória."); return;
        }
        if (isNaN(valorNumerico) || valorNumerico <= 0) {
             showNotification("O valor deve ser um número positivo."); return;
        }
         if (transaction.status === 'pago' && !transaction.data) {
             showNotification("A data é obrigatória para lançamentos pagos."); return;
         }
         if (transaction.status === 'pendente' && !transaction.vencimento) {
             showNotification("A data de vencimento é obrigatória para lançamentos pendentes."); return;
         }
        if (isOperational && !transaction.categoryId) {
            showNotification("A categoria é obrigatória para Receitas e Despesas."); return;
        }
        if (isOperational && transaction.isInstallment && (!transaction.installments || transaction.installments < 2)) {
             showNotification("O número de parcelas deve ser 2 ou mais."); return;
        }

        let dataToSubmit = { ...transaction, valor: valorNumerico };

        if (isOperational) {
            dataToSubmit.categoryName = selectedCategory?.name || '';
            const selectedClient = clients.find(c => c.id === transaction.clientId);
            dataToSubmit.clientName = selectedClient ? selectedClient.nome : '';
            if (!dataToSubmit.formaPagamento) dataToSubmit.formaPagamento = 'pix';
        } else {
            dataToSubmit.categoryId = ''; dataToSubmit.categoryName = '';
            dataToSubmit.clientId = ''; dataToSubmit.clientName = '';
            dataToSubmit.formaPagamento = '';
            dataToSubmit.isInstallment = false;
        }
        delete dataToSubmit.natureza;

        if(dataToSubmit.status === 'pago') {
             dataToSubmit.vencimento = dataToSubmit.vencimento || '';
        } else {
             dataToSubmit.data = dataToSubmit.data || '';
        }


        setIsSaving(true);
        try {
            await onSubmit(dataToSubmit);
             if (!initialData) {
                  const defaultType = 'receita';
                  setTransaction({
                      descricao: '', valor: '', data: new Date().toISOString().split('T')[0],
                      natureza: defaultType, tipo: defaultType,
                      categoryId: '', clientId: '',
                      accountId: accounts && accounts.length > 0 ? accounts[0].id : '', // Reseta para primeira conta
                      isInstallment: false,
                      installments: 2, status: 'pago', vencimento: '',
                      formaPagamento: 'pix',
                  });
             }
        } finally {
            setIsSaving(false);
        }
    };

    const title = initialData ? "Editar Movimentação" : "Nova Movimentação";
    const isOperational = transaction.tipo === 'receita' || transaction.tipo === 'despesa';
    const availableCategories = useMemo(() => {
        if (!isOperational) return [];
        return categories.filter(c => c.type === transaction.tipo);
    }, [categories, transaction.tipo, isOperational]);

    let dateLabel = "Data";
    if (transaction.status === 'pendente') {
         dateLabel = transaction.isInstallment && isOperational ? "Vencimento da 1ª Parcela" : "Data de Vencimento";
    } else {
         dateLabel = transaction.isInstallment && isOperational ? "Data da 1ª Parcela" : "Data";
    }
     const activeDateField = transaction.status === 'pendente' ? 'vencimento' : 'data';
     const activeDateValue = transaction[activeDateField] || '';

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl p-6 w-full max-w-lg">
                <form onSubmit={handleSubmit} className="space-y-4 max-h-[90vh] overflow-y-auto pr-2">
                    <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-200 mb-6">{title}</h2>
                    {isOperational && (
                        <>
                            <div>
                                <label htmlFor="catalog-select" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Selecionar do Catálogo (Opcional)</label>
                                <select id="catalog-select" onChange={handleCatalogSelect} className="mt-1 block w-full form-select dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                                    <option value="">-- Preencher manualmente --</option>
                                    {products.map(p => <option key={p.id} value={p.id}>{p.name} - {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(p.price)}</option>)}
                                </select>
                            </div>
                            <hr className="dark:border-gray-600"/>
                        </>
                    )}
                    <div><label htmlFor="natureza" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Natureza da Movimentação</label><select name="natureza" id="natureza" value={transaction.natureza} onChange={handleChange} className="mt-1 block w-full form-select dark:bg-gray-700 dark:border-gray-600 dark:text-white"><option value="receita">Receita (Venda)</option><option value="despesa">Despesa (Operacional)</option><option value="aporte">Aporte (Capital)</option><option value="retirada">Retirada (Pró-labore)</option></select>{transaction.natureza === 'aporte' && <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">💬 Aportes são investimentos de capital próprio. Eles aumentam seu caixa, mas não contam como receita de vendas.</p>}{transaction.natureza === 'retirada' && <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">💬 Retiradas são para seu uso pessoal (pró-labore). Elas afetam seu caixa, mas não contam como uma despesa do negócio.</p>}</div>

                    {/* --- NOVO CAMPO DE CONTA --- */}
                    <div>
                        <label htmlFor="accountId" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Conta Financeira *</label>
                        <select
                            name="accountId"
                            id="accountId"
                            value={transaction.accountId}
                            onChange={handleChange}
                            required
                            className="mt-1 block w-full form-select dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                        >
                            <option value="" disabled>Selecione a conta...</option>
                            {/* Verifica se 'accounts' existe e é um array antes de mapear */}
                            {Array.isArray(accounts) && accounts.map(acc => (
                                <option key={acc.id} value={acc.id}>{acc.name}</option>
                            ))}
                        </select>
                        {(!Array.isArray(accounts) || accounts.length === 0) && (
                            <p className="mt-1 text-xs text-yellow-600 dark:text-yellow-400">Nenhuma conta cadastrada. Vá ao menu "Contas" para adicionar.</p>
                        )}
                    </div>
                     {/* --- FIM DO CAMPO DE CONTA --- */}

                    <div><label htmlFor="descricao" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Descrição</label><input type="text" name="descricao" id="descricao" value={transaction.descricao} onChange={handleChange} required disabled={isSaving} className="mt-1 block w-full form-input dark:bg-gray-700 dark:border-gray-600 dark:text-white"/></div>
                    <div><label htmlFor="valor" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Valor (R$)</label><input type="text" inputMode="decimal" name="valor" id="valor" value={transaction.valor} onChange={handleChange} required disabled={isSaving} placeholder="150,00" className="mt-1 block w-full form-input dark:bg-gray-700 dark:border-gray-600 dark:text-white"/></div>

                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label htmlFor="status" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Status</label>
                            <select name="status" id="status" value={transaction.status} onChange={handleChange} disabled={isSaving} className="mt-1 block w-full form-select dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                                <option value="pago">Pago</option>
                                <option value="pendente">Pendente</option>
                            </select>
                        </div>
                         <div>
                             <label htmlFor="date-field" className="block text-sm font-medium text-gray-700 dark:text-gray-300">{dateLabel}</label>
                             <input
                                 type="date"
                                 id="date-field"
                                 name={activeDateField}
                                 value={activeDateValue}
                                 onChange={handleChange}
                                 required
                                 disabled={isSaving}
                                 className="mt-1 block w-full form-input dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                             />
                         </div>
                    </div>

                    {isOperational && (
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <label htmlFor="categoryId" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Categoria</label>
                                <select name="categoryId" id="categoryId" value={transaction.categoryId} onChange={handleChange} required={isOperational} className="mt-1 block w-full form-select dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                                    <option value="">Selecione...</option>
                                    {availableCategories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                                </select>
                            </div>
                            <div>
                                <label htmlFor="formaPagamento" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Forma de Pagamento</label>
                                <select name="formaPagamento" id="formaPagamento" value={transaction.formaPagamento} onChange={handleChange} required={isOperational} className="mt-1 block w-full form-select dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                                    <option value="pix">Pix</option>
                                    <option value="dinheiro">Dinheiro</option>
                                    <option value="cartao_credito">Cartão de Crédito</option>
                                    <option value="cartao_debito">Cartão de Débito</option>
                                    <option value="boleto">Boleto</option>
                                    <option value="transferencia">Transferência (TED/DOC)</option>
                                    <option value="outra">Outra</option>
                                </select>
                            </div>
                        </div>
                    )}

                    {isOperational && transaction.tipo === 'receita' && (
                        <div>
                            <label htmlFor="clientId" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Cliente (Opcional)</label>
                            <select name="clientId" id="clientId" value={transaction.clientId || ''} onChange={handleChange} disabled={isSaving} className="mt-1 block w-full form-select dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                                <option value="">Nenhum cliente</option>
                                {clients.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
                            </select>
                        </div>
                    )}

                    <div className="flex items-center space-x-2 pt-2">
                        <input
                             type="checkbox"
                             name="isInstallment"
                             id="isInstallment"
                             checked={transaction.isInstallment}
                             onChange={handleChange}
                             disabled={isSaving || !isOperational}
                             className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 disabled:opacity-50 disabled:cursor-not-allowed"
                        />
                        <label
                             htmlFor="isInstallment"
                             className={`text-sm font-medium ${!isOperational ? 'text-gray-400 dark:text-gray-500 cursor-not-allowed' : 'text-gray-700 dark:text-gray-300'}`}
                        >
                             Lançamento parcelado?
                        </label>
                     </div>
                     {transaction.isInstallment && isOperational && (
                         <div>
                             <label htmlFor="installments" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Número de Parcelas</label>
                             <input
                                 type="number"
                                 name="installments"
                                 id="installments"
                                 min="2"
                                 value={transaction.installments}
                                 onChange={handleChange}
                                 required
                                 disabled={isSaving}
                                 className="mt-1 block w-full form-input dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                             />
                         </div>
                     )}
                    <div className="flex justify-end space-x-4 pt-4"><button type="button" onClick={onCancel} disabled={isSaving} className="px-4 py-2 bg-gray-200 dark:bg-gray-600 dark:text-gray-200 rounded-md hover:bg-gray-300 dark:hover:bg-gray-500">Cancelar</button><button type="submit" disabled={isSaving} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-blue-400">{isSaving ? 'Salvando...' : (initialData ? "Salvar" : "Adicionar")}</button></div>
                </form>
            </div>
        </div>
    );
};